import type {
  Author as AuthorType,
  Dates as DateType
} from 'types/capi/shared';

import Image from '~/components/Image';
import useEnv from '~/hooks/useEnv';
import useRegion from '~/hooks/useRegion';
import { formatArticleDate } from '~/utils/dates';

type Props = {
  author: AuthorType;
  date: DateType;
};

export default function AuthorInfo({ author, date }: Props) {
  const env = useEnv();
  const region = useRegion();

  if (!author) return null;

  return (
    <div className="mr-auto flex items-center">
      <Image
        height={72}
        width={72}
        alt={author.name}
        src={author.avatar}
        loading="lazy"
        className="w-12 rounded-full"
      />
      <div className="ml-6 text-sm text-light-grey">
        <span>
          By{' '}
          <a
            href={`${env.SITE_BASE_URL}${author.path}/`}
            className="text-dark-grey underline"
          >
            {author.name}
          </a>{' '}
          {'  '}
          &bull;{'  '} {author.title}
        </span>
        <span>
          {' '}
          &bull;{'  '} {`${formatArticleDate({ date }, region)}`}
        </span>
      </div>
    </div>
  );
}
